import { toSearchArray } from '@/utils/list-query.ts'

/** 清理旧 URL / 缓存中的归档伪状态，归档条件统一由 archiveStatus 表达。 */
export function toBusinessStatusSearch(value: unknown) {
  const statuses = toSearchArray(value)?.filter((status) => status !== 'archived')
  return statuses?.length ? statuses : undefined
}
